import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=80fcaa10&scoped=true&"
import script from "./OAuthLogin.vue?vue&type=script&lang=js&"
export * from "./OAuthLogin.vue?vue&type=script&lang=js&"
import style0 from "./OAuthLogin.vue?vue&type=style&index=0&id=80fcaa10&prod&lang=scss&scoped=true&"
import style1 from "./OAuthLogin.vue?vue&type=style&index=1&id=80fcaa10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fcaa10",
  null
  
)

export default component.exports